<template>
    <section class="sticky-bottom">
        <div class="sticky-bottom__container">
            <div class="sticky-bottom__container__text">
                <p v-if="infoCase == 1" class="quorum">Trwa sprawdzanie kworum...</p>
                <p v-if="infoCase == 2" class="quorum">Trwa głosowanie w sprawie: {{elemToDispay}}</p>
                <div v-if="infoCase == 3" class="quorum">
                    <p class="p-break">Trwa przerwa w obradach</p>
                    <p>Szacowana godzina wznowienia: {{elemToDispay}}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "InfoModal",
    data() {
        return {

        };
    },
    props: {
        infoCase: Number,
        elemToDispay: String
    },
    components: {

    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
};
</script>

<style lang="scss" scoped>

    .p-break {
        font-size: 2.0em;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .sticky-bottom {
        position: -webkit-fixed;
        position: fixed;
        bottom: 0;
        border-color: red;
        background: radial-gradient( 100% 100% at 0% 0%, #00082c 0%, #004dcc 100% );
        height: 140px;
        left: 0px;
        right: 0px;
        padding: 50px;

        &__container {
            display: flex;
            font-size: 35px;
            line-height: 144%;
            color: white;
            padding: 25px;

            &__text {
                margin: 10px;
                display: unset;
            }
        }
    }

    .quorum {
        color: white;
        animation: pulse 4s infinite;
    }

    @keyframes pulse {
        0% {
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>